exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".VirtualListWithKeyboard_menuContainer__3RXtt{max-height:25rem}.VirtualListWithKeyboard_empty__qv1G4{padding:.625rem}", ""]);

// exports
exports.locals = {
	"menuContainer": "VirtualListWithKeyboard_menuContainer__3RXtt",
	"empty": "VirtualListWithKeyboard_empty__qv1G4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/VirtualListWithKeyboard/VirtualListWithKeyboard.less
// module id = 1639
// module chunks = 8